import { render } from "./accordion.vue?vue&type=template&id=5c55402b"
import script from "./accordion.vue?vue&type=script&lang=js"
export * from "./accordion.vue?vue&type=script&lang=js"

import exportComponent from "/Users/asani/Documents/NODE/Graduation/fe-gradu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__